import * as types from './task-modals.types';

export const taskModalSelectors: types.ITaskModalSelectors = {
  selectTaskModalStatus: (state, key) => state.taskModals[key].open,
  selectTaskModals: (state) => Object.values(state.taskModals),
};
